import { useBrowserLocation, useWindowSize } from "@vueuse/core";
import { computed } from "vue";

type PageAttributes = {
  formGroupId: number | null;
  formId: number | null;
};

function getBrowserAttributes() {
  const browserLocation = useBrowserLocation();

  return {
    screenWidth: useWindowSize().width,
    url: computed(
      () => `${browserLocation.value.origin}${browserLocation.value.pathname}`,
    ),
    urlFull: computed(() => browserLocation.value.href ?? ""),
    urlPath: computed(() => browserLocation.value.pathname ?? ""),
    urlDomain: computed(() => browserLocation.value.host ?? ""),
  };
}

export { getBrowserAttributes };
export type { PageAttributes };
